var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-6983 5862.225 502.708 695.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bababa;\n      }\n\n      .cls-2 {\n        fill: #eaeaea;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .active {\n        fill: #ed1c24;\n      }\n\n      .starting {\n        fill: #ffc529;\n      }\n\n      .proposed {\n        fill: #7e7f7f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528",
    transform: "translate(-7332.014 4807.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard 1",
    transform: "translate(349.014 1054.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Countries"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gGBR",
    transform: "translate(134.887)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P1-2",
    className: "cls-1",
    d: "M196.448,350.429l-3.946,1.717-1.579,2.585-1.006,1.006-2.427.3-2.427-.434-8.09-6.886L175,348.574l2.427-2.151,5.92-1.144,3.433-2.289,6.886,3.946,2.861,3.591Z",
    transform: "translate(35.42 333.793)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P2",
    className: "cls-1",
    d: "M144.3,248.971l1.44,1.578,4.163.71-1.855,2.427-5.426,2.151-3.729,2.427-4.3,1.855-1.283-3.3-2.151-.434-1.973-6.314,1.283-8.6,4.578-1.283,5.92,1.283,3.3,7.459Z",
    transform: "translate(-9.161 233.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P3",
    className: "cls-1",
    d: "M148.55,170.594l4.874,3.019,3.946.868,2.289,5.742.138,8.031,2.585,8.6,4.163,7.893-.71,4.163-2.585,1.717-4.874,1.717-.71,2.861,3.157-.868h2.723l5.742,1.855,1.44,3.433.434,4.736v3.729l-1.44,3.946-1.283-1.579-.868-3.946-1.44-1.973-1.973-1.44-.138,5.012-1.855,6.452.868.71,2.723.868-3.394,6.058-4.44.868-4.736-.434-1.579,2.151-1.579,2.861-3.453,3.848-3.729,1.855-3.729-1.44-3.3-2.861-3.3-1.283-2.585.71-1.717.71-1.44-.572-4.3-.572-3.946-1.006-.138-1.855,1.973-5.15-.572-1.579-3.591-1.579-1.006-1.579-1.283-4.163v-1.855l.3-2.427-1.44-3.433-2.289-2.861-1.4-.631-3.946,2.723-3.591,3.019.434,1.973.3,2.585-1.855,1.283-5.308,2.861L94.11,235.65l-1.44.434-1.855-1.579-5.15-1.006-2.289-1.283L81.4,228.625l-6.156-3.591V220.16l-1.006-1.144-5.584-9.866-.3-2.861,1.44-1.283,3.433-1.579,10.616-1.44,1.855-1.144.71-1.44-2.427-2.289-1.973-2.289-.572-1.44.3-1.006,1.717-.868,2.861.572,2.151,1.144,1.973-.71,3.433-.3,2.585-1.006,2.763-3.2L101.944,185l.71-1.855,3.3-6.018,1.44-1.44,7.025-2.723.868,2.585,2.861,1.44,3.157-1.579,4.874-6.018,2.289.138,2.289,1.144,4.874.3,9.175-1.144Z",
    transform: "translate(-68.36 164.848)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P4",
    className: "cls-1",
    d: "M138.839,177.851l-4.736-.868-1.579-1.006-1.717-2.151-.138-9.609,1.579-3.157,1.283-1.283,1.283-1.006H137.4l2.151,2.289.572,1.717.572,6.729-.71,5.446-1.144,2.861Z",
    transform: "translate(-7.721 154.513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P5",
    className: "cls-1",
    d: "M127.816,147.81l-.71,8.879v5.584l-.434,1.855-1.855,2.151-6.886,1.973-1.973-.434.138-.868,2.289-3.157-.3-3.946,1.283-2.861-.434-.71-1.283.138-5.446,3.729H110.63v-1.006L112.6,155.7l.868-2.585,1.006-1.579,1.579-1.144,1.717-.71h1.144l.868,1.44,4.44-2.289,3.591-1.006Z",
    transform: "translate(-27.223 143.846)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P6",
    className: "cls-1",
    d: "M123,161.567l-1.006.572-1.855-.572-.434-1.283.138-1.717.572-3.019,1.717-1.973,5.584-2.151-1.855-1.579.138-.868,1.855-2.427,6.156-3.157,1.579-.434,1.283.434-4.44,7.025-9.452,11.188Z",
    transform: "translate(-18.397 139.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P7",
    className: "cls-1",
    d: "M139.392,146.852l-15.47.3-5.012-1.44v-1.855l1.283-1.006,4.44-.3,3.946-8.465-5.229-5.624V127.18l.868-1.717,1.006-.71,4.3-1.283h1.717l1.144.572,2.151,3.019,1.717,5.742,3.946,1.717,2.151,2.723-2.861,9.609Z",
    transform: "translate(-19.165 120.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P8",
    className: "cls-1",
    d: "M117.061,126.082l-2.151-.138v-1.1l4.736-3.591,2.427-.138.71.572-2.289,2.151Z",
    transform: "translate(-23.058 117.862)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P9",
    className: "cls-1",
    d: "M106.79,109.127l-3.433.138-1.006-.868v-.868l1.283-2.151,2.723-.138,1.283,1.579V108.1l-.868,1.006Z",
    transform: "translate(-35.281 102.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P10",
    className: "cls-1",
    d: "M127.546,115.188l-1.283.71-1.283-.572-1.144-1.44-1.006-3.433,4.578-1.283,1.283,1.579.138,1.717-.3,1.579-1.006,1.144Z",
    transform: "translate(-15.351 106.243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P11",
    className: "cls-1",
    d: "M111.258,112.311h-1.717l-1.855-.868-.868-1.283-.138-4.44.434-2.427,1.717-4.44,1.44-5.584,3.946.868.868,1.006L111.258,111.6l-.138.71Z",
    transform: "translate(-31.067 90.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P12",
    className: "cls-1",
    d: "M143.577,100.691l-.868,3.019-1.5,3.3-.138,3.946-.434,2.585,1.283,1.283.572,1.44,6.452,2.861,6.314,1.006.868,1.44-.3,1.717-1.44,1.579-4.3,2.723-5.742,4.578-1.44.868-1.44-.3-.868-.71L142.314,122l-4.874.138-3.729-1.006-1.717-1.717-.71-2.585-1.44-6.729-7.6-4.3-1.44-3.946-.3-2.151.572-1.006,2.427-1.973,1.855,1.44,1.44-.3L127.949,97l.138-.868-.434-2.486.138-.71,9.175-.71,1.717-3.946,1.973.138,1.717,1.855,1.717,5.012-.572,5.446Z",
    transform: "translate(-17.608 85.913)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P13",
    className: "cls-1",
    d: "M120.765,84.136l3.019,4.736-4.736,5.446-4.874-1.283-5.584-6.156.138-1.006,1.006-1.144,1.283-.868h1.144L113.6,85l2.723-.572,1.717.868,2.723-1.144Z",
    transform: "translate(-29.209 81.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P14",
    className: "cls-1",
    d: "M158.373,70.318l-7.459,10.458-1.717-.138-2.289,2.585-5.446,2.151,3.946,1.006.868,1.283-.572,2.289L144.7,91.1l-6.729,3.946-4.163,1.144-5.387,4.676-1.973-.434-2.861,3.019-2.151,1.144-.868-.138-.868-1.006-1.579-4.163,5.426-2.368.868-1.717,3.591-1.283-.138-.71-3.946-3.946-1.44-2.427.434-.868,2.861-1.579-1.006-.572-.434-1.283-1.283-.868V80.519l.434-2.861,1.144-2.861,1.717-.868,1.006-1.283.71-.3,1.855,1.283,1.579,2.861,2.861-.3,2.861,1.144.138-.572-.71-6.156.71-1.144,1.579-1.006,7.893-2.427,10.32-4.874,2.289-.572.434,1.144-.138,3.729L158.452,70.2Z",
    transform: "translate(-19.934 58.965)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P15",
    className: "cls-1",
    d: "M302.318,80.531l-.868,5.584-.71,1.579-1.283,1.855-3.433,3.3-8.169,4.163-15.47,10.024-8.879,4.736-1.717,2.723-1.44,3.946,4.321,1.875,1.579,1.717-1.579,1.855L256.2,129.9l-3.374,6.2,5.308.868,4.578-.434,9.373-2.407,8.741-1.579,3.946.71L291.8,137.2l1.579.434,3.433-.572,3.3.434,21.705,4.736,6.452-.434,3.729,2.427,2.585,4.874,1.717,8.6-.434,1.283-2.585,3.3-4.44,3.946-4.3,5.92-1.578,3.157-1.283,3.591-1.579,3.3-9.313,15.055-7.735,7.735L299.1,210.9l-4.38,4.124-3.946,2.585-3.946,1.579-10.616.3-3.157,1.144-3.946,2.151-3.946.71,4.3.572,4.3-.71,7.6.71,7.6,7.025-1.579,4.163-4.163,2.861-8.031-1.006-8.879,6.314-3.946,1.717-3.729.572-4.3-1.283-7.6-3.591-3.157-2.861L246,242.134l3.3,2.585,19.929,8.307,1.44-.3,7.6-3.3,8.879,1.579,15.332,11.464,3.729,7.163,5.821,10.5,3.157,4.3,2.289,3.729.868,5.15.434,16.634,1.145,16.476,2.151,17.916,1.44,5.012,2.585,3.946,14.187,10.182L343.3,366.5l4.874,8.307,4.578,8.741,4.44,6.886,5.15,5.742-3.3,2.151-2.585,3.729.71,5.584,1.579,5.584,3.591,9.037,2.861,9.609-1.44-1.579-1.44-1.006h-2.289l-2.151-.868-3.591-3.3-3.3-4.163-7.893.3-4.163-1.283-3.729-.434,6.729,3.019,7.6,1.283L364.157,441.6l4.44,9.866,1.717,12.332-3.019,5.012-3.966,2.98-3.946,3.433-3.946,4.2,8.6,7.893,2.151.138,2.151-.71,2.427-1.855,4.163-5.012,1.973-1.717,6.018.138,5.012,1.006,4.736,1.855,4.44.3,8.6,3.433,4.163,2.723,10.182,10.892,1.717,5.446.3,6.886-.71,7.6-2.782,6.531-3.019,5.92-2.309,7.735-1.283,2.723-1.717,2.151-6.886,5.584-4.3,1.973-1.579-1.283-1.855-.138-.434,1.44,1.579,3.591-.434,3.946-3.946,2.289-3.946.868-5.92-2.427-9.175,4.3,5.742,3.591.868,3.019-2.289,4.874-4.163,1.855-4.44.434-4.3-.434-3.946.868-3.946,1.855,4.578-.71,2.861,1.578,1.283,4.578,1.578,1.441,8.465,3.019,5.308.71,10.32.3,5.012.572,1.579,1.006-.434,3.591-1.855,8.741-1.579,1.717-14.424,5.387-3.433,4.736-1.145,3.019-8.031-1.578L362.8,620.67l-6.886,1.283-5.308,1.579-5.308,2.289-4.163.3L324.082,620.1l-10.616-1.283-14.621.868-3.591-1.006-5.15-3.946L284.8,611.87l-6.314-1.855-5.15-3.591,2.723,5.742-8.6,3.729-3.729.434-3.729-.868-7.735.138-7.024-1.973.572,3.729,1.283,3.433-1.717,1.144h-1.717l-12.9-4.736-1.973.138L226.8,619.19l-4.736-1.973-3.946-4.44-4.755-3.394-5.012-1.973-4.3-.434L185.86,609.4l-4.578,5.012-3.157,7.735-3.946,6.729-5.15,4.736-5.012-.3-3.729-4.736-7.893-5.919-2.17-3.394-1.006-.434-1.144.868-3.591.572-3.591-.71h-5.584l-10.024,1.578-4.3,1.44-9.452,4.736-2.151,1.441-4.3,5.742-4.736.138-3.3-5.012-4.44-2.427-5.308.3-3.433,1.44-1.006-1.973.71-3.729,4.617-3.71,10.458-1.145,10.339-6.748,5.15-4.3,2.289-2.585,2.427-1.44,2.861-.138,1.973-3.019,14.325-10.6,1.579-2.723,1.717-5.308,1.973-5.012,10.182-1.282,6.729-10.024,1.44-.572,13.615.71,9.748,1.973,9.313,3.946,5.012,1.145,5.15.3,4.44-2.289,8.6-9.314,4.736-3.946,5.012-3.433,4.874-3.946,8.169-7.735-4.874,2.289-6.314,3.946-3.473,2.19-10.32,1.006-4.874,2.151-8.6,5.15-1.579.3-10.892-3.729-6.59-10.182-4.736-4.578-1.973-.868-2.585.572-5.012.138-4.874-1.144,3.3-3.433,3.946-1.578-7.3-3.019-1.855-1.717-1.855-3.157-5.92-1.717H150.9l-5.584,2.723-8.465,2.151-7.893-7.3-1.283-2.723,1.006-4.44-.572-3.946-2.289-1.855,4.3-3.946,4.321-2.21,9.313-1.145,14.483-4.578,7.893-1.717,7.893-3.946L177.454,489l2.861-3.946,3.157-5.15,3.729-3.946-2.427-1.717-.572-3.591,1.006-3.3,1.855-2.861-.3-3.946-1.283-4.44.868-3.019,1.144-3.3-5.15-.868H177.06l-5.15,1.441-5.15,2.289-3.946-.3.572-2.585,2.427-2.723,5.446-3.591,5.584-2.723,2.289-2.585,1.973-3.019,3.019-2.151,7.3-3.729,13.181-3.3,1.855.138,4.578,1.579h4.736l4.44-1.283,4.163.434,8.031,7.6-1.006-9.609,4.44-1.44,4.3,9.313,1.973,1.283,4.874-.434-1.579-1.717-1.973-.434-2.447-1.875-1.855-3.019-2.092-9.017,1.144-5.012,3.591-4.578,3.729-4.3-2.289-1.44-1.44-2.151.3-4.736,1.579-4.163,5.742-2.723,2.585-5.308L253.7,376.9l-.3-2.861-5.012-.572-2.585.71-2.427,1.44-2.289-.434-4.736-8.031-2.427-5.92L229.981,349.2l.434-6.729,7.893-13.043,9.313-7.6,9.452-1.44-1.579-1.006L242.017,316.8l-4.736.138-4.874,2.861-2.585.71-2.585-.138-2.585,1.44-2.723,2.151-2.585,1.144-4.44-1.44-2.289.138-1.283-1.717-.868-2.723-1.579-1.006-1.973.3-4.736,2.427-4.578,1.144-4.578-3.157-5.584-5.15-1.717,1.006-2.151,3.3-2.151,5.446-3.433-5.92-2.585-7.3-.434-4.3,1.006-4.578,2.585-1.283,1.855,2.151,5.92-10.182,10.024-12.609,3.3-3.591,2.861-5.012.434-3.591-.868-3.3-4.736-8.169,1.283-5.446,2.151-6.018,2.585-3.433.868-.434,8.169,1.717-2.98-2.466-5.15-6.886.572-1.973,2.585-4.874-.71.434-1.973,1.973-3.946,5.308-1.973,1.006-4.736.434-1.579,2.585-.868.572-2.289-.138-1.283,2.585H187.5v-3.019l1.006-4.736,1.855-4.163,2.585-3.157,8.465-6.314-3.946,1.717-8.879,5.584-4.815,3.966-1.44,1.44-.572,1.283-.3,1.579-.3,8.6-1.44,3.729-12.332,24.073-1.717,2.289-1.44,1.006-1.144.138-3.019-1.144-1.006-2.289.572-2.151,1.283-3.157,5.446-11.464,1.973-3.019L170.765,249l5.012-4.736v-.3l-2.723.434-1.006-.572-.572-1.144,4.44-16.2,3.157-4.874,2.585-7.459,3.3-6.314,3.157-4.44,3.019-5.742,2.861-2.289,1.579-3.946,3.729-3.946,3.019-4.3-1.144.138-15.43,9.432-3.729,1.579-4.3-1.579-3.019-2.151L172.837,187l.138-5.92-3.157-.868-2.585-1.579.3-.71,4.3-2.289,5.92.3,6.59-3.729-3.946-4.44.71-.868,4.736-1.855,7.6-8.307,3.157-8.465-1.579-4.578-.3-2.861-4.163-4.163.138-3.946,1.006-1.973,2.151-1.717,2.861-1.006,4.163-.71-3.019-2.427-.868-2.289-.3-3.019.3-1.717,3.591-6.886,1.717-2.723,3.019-3.433,9.037,2.289,1.44-1.44,1.144.138,4.321,2.526-.434-1.855-5.308-10.892-.3-1.855,3.3-4.44.71-2.151.3-2.427,1.006-1.579,2.585-.3,7.3,1.579,1.973-.434-.3-2.585-.967-3.453.3-2.723,1.006-2.151,1.144-4.736.868-1.855,2.427-2.723,1.579-.71,1.855-.138,3.946,1.855,1.144,1.579,1.144,3.433h1.283l5.742-2.151,1.579-.138,1.144,4.163,9.175-1.283L277.3,71.375l7.3-.572,7.3.71,7.3-1.006,6.709,2.447v1.283l-.71,1.717-2.861,4.578Z",
    transform: "translate(-54.249 61.223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P16",
    className: "cls-1",
    d: "M200.007,67.982l-.3.138L198.7,66.542l-1.144-4.736,3.433-.3,1.381.967-1.006,1.717-1.44,3.946Z",
    transform: "translate(57.375 59.861)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P17",
    className: "cls-1",
    d: "M198.367,66.919l-2.151.572-1.855-.434-2.249-4.44L191.54,59.6l.572-1.855,1.44-.434,2.723,1.579.868,3.433-.138,2.151.138.868,1.717,1.144-.434.434Z",
    transform: "translate(51.517 55.773)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P18",
    className: "cls-1",
    d: "M203.816,58.978l-.71,1.579,2.585.434,3.433,2.151,2.289.572,1.579,2.151-1.717,3.019-1.283.71h-1.421l-3.729-4.163-6.314.3-1.006-.572-.71-1.144V62.865l.434-2.289-.138-.71-2.585,1.717-.868-.434L193.22,60l.3-2.151.868-3.019,2.151-4.163L198.705,50l3.157,1.144,3.019,3.157.868,1.717-.3,1.283-1.717,1.579Z",
    transform: "translate(53.152 48.659)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P19",
    className: "cls-1",
    d: "M210.776,51.794l-3.946-.71,2.723-3.591,2.585-.572,4.3,1.283-1.144,1.579-4.578,1.973Z",
    transform: "translate(66.397 45.662)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P20",
    className: "cls-1",
    d: "M209.945,56.422l-3.3,1.006-1.006-1.579.572-4.3-3.157-2.585-1.44-1.44L200.75,45.1l.434-.572,2.427-.434,3.157,4.578.868,3.591,2.723,1.44.3.572-.71,2.151Z",
    transform: "translate(60.48 42.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P21",
    className: "cls-1",
    d: "M246.024,11.27l-.3,4.874,1.973-1.006,1.717,5.012,1.283.138,2.585-1.44-1.144,4.163L247.7,34.336l-1.006,1.855-1.006,3.433-.572.71-1.973,7.025L241.17,49.51l-2.289,5.446-.71.434-1.44-2.427,3.433-8.307,1.717-4.874V37.059l-.71-2.585-2.861-.434-2.585.572-.3-1.44.3-1.855-.434-.71-3.3-.434-.848-.592-.3-1.855.138-1.44,3.157-.572,2.585.868,4.578-1.973-.868-9.452L237.263,13.8l-.572-1.006.868-1.44,1.973-.572,3.591-4.163,1.835-.513,1.973.572-1.006,4.578Z",
    transform: "translate(89.773 5.936)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P22",
    className: "cls-1",
    d: "M244.289,17.159l-1.006.572-1.973-7.3,3.946-7.3,2.723.71.138,1.973-.572,1.855h-1.579l-.138.572-.3,3.591-.888,4.321-.434,1.006Z",
    transform: "translate(99.952 3.046)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polyF1S77P23",
    className: "cls-1",
    d: "M252.254,1.579l-.138.868-2.723,5.308-.434,2.111-2.723-.572-.3-.71V5.308l1.006-3.433.572-.868.868-.3.71.868L250.814,0l.71.3.71,1.283Z",
    transform: "translate(104.458)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gIRL",
    transform: "translate(0 318.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S102P2",
    className: "cls-2",
    d: "M172.417,184.833l-3.3,6.018-.71,1.855-2.664,3.019-2.861,3.3-2.585,1.006-3.433.3-1.973.71-2.151-1.144-2.861-.572-1.717.868-.3,1.006.572,1.44,1.973,2.289,2.427,2.289-.71,1.44-1.855,1.144-10.616,1.44-3.433,1.579-1.44,1.283.3,2.861,5.584,9.866,1.006,1.144v4.874l6.156,3.591,1.973,3.591,2.289,1.283,5.15,1.006,1.855,1.579,1.44-.434,1.006-1.283,5.308-2.861,1.855-1.283-.3-2.585-.434-1.973,3.591-3.019,4.045-2.822,1.579.572,2.289,2.861,1.44,3.433-.3,2.427v1.855l1.283,4.163,1.006,1.579,3.591,1.579.572,1.579-1.973,5.15.138,1.855,3.946,1.006,4.3.572,1.44.572,1.717-.71,2.585-.71,3.3,1.283,1.006,2.723.138,2.585-3.019.3-2.861-1.283-1.855,1.283-.868,3.019.138,4.163,1.283,3.3v6.729l-.3,7.3,1.006,4.736-.71,5.308-1.144,2.644-.71,4.736-1.283,1.44-.3,4.578.3,9.609v5.15L191.4,336.156l-2.723,3.729-3.2,3.453-2.723,4.163-2.289,4.736-2.585,7.893-7.459,8.307-2.7,1.855-2.861.868,3.946,7.893-5.308,1.855-5.15-.3-4.992-3.019-3.591-.572-3.591,1.441-1.579,1.006-.71-.868-.868-6.018-2.92,5.308L136.5,378.9l-5.308-1.717-9.313-.868-3.946.71-2.151,2.151-1.717,2.585-1.855,1.283-1.855.572-7.459.3-1.717.572-4.3,3.729-5.012,1.579-3.729-.138-2.427-3.433-.868-1.973L83.7,383.1l-4.775-1.2,1.283,1.144.434,2.151-.434,3.946-1.44,3.3-2.861,1.283-2.9-.493-5.446,2.427-6.156-.572-4.163,2.585-21.074.3-1.006-.138-2.289-2.289-2.723-1.44-3.157-.434-9.037,1.006-3.729-1.855,7.3-6.452L29.42,384.2l1.006-.868-2.151-1.144L14.8,381.322l-5.15,1.006-4.578-.572,3.019-3.019,7.163-3.3L18.982,374l2.151-.434,3.019-2.289,6.886-1.579L9.866,370.864l-4.874-2.289-.71-2.289-4.163-.3L0,360.979l7.893-5.091,4.3-1.973,4.44-.572,4.578-1.144,2.151-2.427-1.44-1.44-11.839-2.723-5.347-2.269.868-2.151L7.459,338.9l6.886-2.585,3.3.3,2.723,1.145,2.427,1.855,1.717,2.151,6.729,1.006-1.855-3.433,1.006-5.742-1.44-2.427,3.3-1.855,3.591-.71,6.59-3.946,1.973-.3,10.32,1.579,11.6.138,11.839-.868-5.012-3.729-1.855-3.591-5.742,4.578L61.82,323.9l-8.879-1.283-2.585-1.283-3.2-2.94-1.44.434-1.44,1.006-6.452,1.283-6.156-1.145,8.465-3.157L51.3,310.5l2.861-2.151,3.946-3.946-.138-2.427-1.44-1.717,9.037-8.169,2.723-1.283,4.163.868,3.433-.71,1.283.434,1.44-.3,3.374-2.309-3.433-3.019-3.946-2.151-12.984-2.723-1.579-.71-1.44-1.283-.572-1.579.138-3.591-.71-1.144-2.861-.71-3.157.138-1.855-.71-1.579-1.973,4.163-2.585L48.225,264.9l-4.163-.572-3.019-1.973.434-2.151,2.151-1.717-1.283-2.585.3-2.723,2.585-.71,2.151,1.144,5.308-.572,6.314.868-4.736-3.433-1.579-2.151.71-2.585,1.006-1.973,7.025-1.855,6.729.3.3-2.585,1.144-2.427-6.156-2.585H56.611l2.151-4.578,2.723-3.946,1.144-2.861.71-3.157-3.433.434,1.006-4.44-.434-3.3-4.874.71,1.283-3.946,1.973-2.427,2.585-.572,2.151,1.144,4.163,1.283,4.736-1.006,6.018,1.144,9.037,3.3,4.736,7.735,1.973-.71L97.85,216.4h1.44l9.235,4.262,5.446,3.729,1.717-.3.3-4.3-1.283-3.433,3.69-3.019,3.946-1.717,2.427-.71,5.308-.3,2.427-.868,2.723-4.578,3.433-3.433L125.909,200.6l-10.32-7.893,2.8-2.861,2.861-1.144,4.578-.434,1.006-1.579,2.427-.868,4.578-3.019.138-5.308,1.717-3.433,3.157-1.717,1.717-3.3,1.717-2.151,5.446.434,5.446-1.144,1.717.71,6.018,1.006,1.717,1.44.572-4.3,3.729.434,1.144,1.144-.138,3.157,1.144,2.289-.434,3.3-1.717,2.289-2.289,1.44,1.144,2.427-3.591,3.019,3.157-.868,5.012-2.585.434-2.861.3-3.729-.138-3.591,1.44-3.433,2.723-1.717,6.156.3-1.283-4.578,2.151.138,2.151,1.44,2.585,3.946,2.881,3.414,3.3,2.861-4.578,3.058-5.15,1.717L180.9,180.63l-7.025,2.723-1.44,1.44Z",
    transform: "translate(0 -161.47)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Coastline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g15982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gCountries-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gF1S136-29",
    transform: "translate(163.498 124.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S136P1-3",
    className: "cls-3",
    d: "M258.039,137l4.578-.434,9.471-2.447,8.741-1.579,3.946.71L291.8,137.2l1.579.434,3.433-.572,3.3.434,21.705,4.736,6.452-.434,3.729,2.427,2.585,4.874,1.717,8.6-.434,1.283-2.585,3.3-4.44,3.946-4.3,5.92-1.578,3.157-1.283,3.591-1.579,3.3-9.313,15.055-7.735,7.735L299.1,210.9l-4.38,4.124-3.946,2.585-3.946,1.579-10.616.3-3.157,1.144-3.946,2.151-3.946.71,4.3.572,4.3-.71,7.6.71,7.6,7.025-1.579,4.163-4.163,2.861-8.031-1.006-8.879,6.314-3.946,1.717-3.729.572-4.3-1.283-7.6-3.591-3.157-2.861L246,242.134l3.3,2.585,19.929,8.307,1.44-.3,7.6-3.3,8.879,1.579,15.332,11.464,3.729,7.163,5.821,10.5,3.157,4.3,2.289,3.729.868,5.15.434,16.634,1.145,16.476,2.151,17.916,1.44,5.012,2.585,3.946,14.187,10.182L343.3,366.5l4.874,8.307,4.578,8.741,4.44,6.886,5.15,5.742-3.3,2.151-2.585,3.729.71,5.584,1.579,5.584,3.591,9.037,2.861,9.609-1.44-1.579-1.44-1.006h-2.289l-2.151-.868-3.591-3.3-3.3-4.163-7.893.3-4.163-1.283-3.729-.434,6.729,3.019,7.6,1.283L364.157,441.6l4.44,9.866,1.717,12.332-3.019,5.012-3.966,2.98-3.946,3.433-3.946,4.2,8.6,7.893,2.151.138,2.151-.71,2.427-1.855,4.163-5.012,1.973-1.717,6.018.138,5.012,1.006,4.736,1.855,4.44.3,8.6,3.433,4.163,2.723,10.182,10.892,1.717,5.446.3,6.886-.71,7.6-2.782,6.531-3.019,5.92-2.309,7.735-1.283,2.723-1.717,2.151-6.886,5.584-4.3,1.973-1.579-1.283-1.855-.138-.434,1.44,1.579,3.591-.434,3.946-3.946,2.289-3.946.868-5.92-2.427-9.175,4.3,5.742,3.591.868,3.019-2.289,4.874-4.163,1.855-4.44.434-4.3-.434-3.946.868-3.946,1.855,4.578-.71,2.861,1.578,1.283,4.578,1.578,1.441,8.465,3.019,5.308.71,10.32.3,5.012.572,1.579,1.006-.434,3.591-1.855,8.741-1.579,1.717-14.424,5.387-3.433,4.736-1.145,3.019-8.031-1.578L362.8,620.67l-6.886,1.283-5.308,1.579-5.308,2.289-4.163.3L324.082,620.1l-10.616-1.283-14.621.868-3.591-1.006-5.15-3.946L284.8,611.87l-6.314-1.855-5.15-3.591,2.723,5.742-8.6,3.729-3.729.434-3.729-.868-7.735.138-7.024-1.973.572,3.729,1.283,3.433-1.717,1.144h-1.717l-12.9-4.736-1.973.138L226.8,619.19l-4.736-1.973-3.946-4.44-4.755-3.394-5.012-1.973-4.3-.434L185.86,609.4l-4.578,5.012-3.157,7.735-3.946,6.729-5.15,4.736-5.012-.3-3.729-4.736-7.893-5.919-2.17-3.394-1.006-.434-1.144.868-3.591.572-3.591-.71h-5.584l-10.024,1.578-4.3,1.44-9.452,4.736-2.151,1.441-4.3,5.742-4.736.138-3.3-5.012-4.44-2.427-5.308.3-3.433,1.44-1.006-1.973.71-3.729,4.617-3.71,10.458-1.145,10.339-6.748,5.15-4.3,2.289-2.585,2.427-1.44,2.861-.138,1.973-3.019,14.325-10.6,1.579-2.723,1.717-5.308,1.973-5.012,10.182-1.282,6.729-10.024,1.44-.572,13.615.71,9.748,1.973,9.313,3.946,5.012,1.145,5.15.3,4.44-2.289,8.6-9.314,4.736-3.946,5.012-3.433,4.874-3.946,8.169-7.735-4.874,2.289-6.314,3.946-3.473,2.19-10.32,1.006-4.874,2.151-8.6,5.15-1.579.3-10.892-3.729-6.59-10.182-4.736-4.578-1.973-.868-2.585.572-5.012.138-4.874-1.144,3.3-3.433,3.946-1.578-7.3-3.019-1.855-1.717-1.855-3.157-5.92-1.717H150.9l-5.584,2.723-8.465,2.151-7.893-7.3-1.283-2.723,1.006-4.44-.572-3.946-2.289-1.855,4.3-3.946,4.321-2.21,9.313-1.145,14.483-4.578,7.893-1.717,7.893-3.946L177.454,489l2.861-3.946,3.157-5.15,3.729-3.946-2.427-1.717-.572-3.591,1.006-3.3,1.855-2.861-.3-3.946-1.283-4.44.868-3.019,1.144-3.3-5.15-.868H177.06l-5.15,1.441-5.15,2.289-3.946-.3.572-2.585,2.427-2.723,5.446-3.591,5.584-2.723,2.289-2.585,1.973-3.019,3.019-2.151,7.3-3.729,13.181-3.3,1.855.138,4.578,1.579h4.736l4.44-1.283,4.163.434,8.031,7.6-1.006-9.609,4.44-1.44,4.3,9.313,1.973,1.283,4.874-.434-1.579-1.717-1.973-.434-2.447-1.875-1.855-3.019-2.092-9.017,1.144-5.012,3.591-4.578,3.729-4.3-2.289-1.44-1.44-2.151.3-4.736,1.579-4.163,5.742-2.723,2.585-5.308L253.7,376.9l-.3-2.861-5.012-.572-2.585.71-2.427,1.44-2.289-.434-4.736-8.031-2.427-5.92L229.981,349.2l.434-6.729,7.893-13.043,9.313-7.6,9.452-1.44-1.579-1.006L242.017,316.8l-4.736.138-4.874,2.861-2.585.71-2.585-.138-2.585,1.44-2.723,2.151-2.585,1.144-4.44-1.44-2.289.138-1.283-1.717-.868-2.723-1.579-1.006-1.973.3-4.736,2.427-4.578,1.144-4.578-3.157-5.584-5.15-1.717,1.006-2.151,3.3-2.151,5.446-3.433-5.92-2.585-7.3-.434-4.3,1.006-4.578,2.585-1.283,1.855,2.151,5.92-10.182,10.024-12.609,3.3-3.591,2.861-5.012.434-3.591-.868-3.3-4.736-8.169,1.283-5.446,2.151-6.018,2.585-3.433.868-.434,8.169,1.717-2.98-2.466-5.15-6.886.572-1.973,2.585-4.874-.71.434-1.973,1.973-3.946,5.308-1.973,1.006-4.736.434-1.579,2.585-.868.572-2.289-.138-1.283,2.585H187.5v-3.019l1.006-4.736,1.855-4.163,2.585-3.157,8.465-6.314-3.946,1.717-8.879,5.584-4.815,3.966-1.44,1.44-.572,1.283-.3,1.579-.3,8.6-1.44,3.729-12.332,24.073-1.717,2.289-1.44,1.006-1.144.138-3.019-1.144-1.006-2.289.572-2.151,1.283-3.157,5.446-11.464,1.973-3.019L170.765,249l5.012-4.736v-.3l-2.723.434-1.006-.572-.572-1.144,4.44-16.2,3.157-4.874,2.585-7.459,3.3-6.314,3.157-4.44,3.019-5.742,2.861-2.289,1.579-3.946,3.729-3.946,3.019-4.3-1.144.138-15.43,9.432-3.729,1.579-4.3-1.579-3.019-2.151L172.837,187l.138-5.92-3.157-.868-2.585-1.579.3-.71,4.3-2.289,5.92.3,6.59-3.729-3.946-4.44.71-.868,4.736-1.855,7.6-8.307,3.157-8.465-1.579-4.578-.3-2.861-4.163-4.163.138-3.946,1.006-1.973,2.151-1.717,2.861-1.006,4.163-.71-3.019-2.427-.868-2.289-.3-3.019.3-1.717,3.591-6.886,1.717-2.723,3.019-3.433,9.037,2.289,1.44-1.44,1.144.138,4.321,2.526-.434-1.855-5.308-10.892-.3-1.855,3.3-4.44.71-2.151.3-2.427,1.006-1.579,2.585-.3,7.3,1.579,1.973-.434-.3-2.585-.967-3.453.3-2.723,1.006-2.151,1.144-4.736.868-1.855,2.427-2.723,1.579-.71,1.855-.138,3.946,1.855,1.144,1.579,1.144,3.433h1.283l5.742-2.151,1.579-.138,1.144,4.163,9.175-1.283L277.3,71.375l7.3-.572,7.3.71,7.3-1.006,6.709,2.447v1.283l-.71,1.717-2.861,4.578-.868,5.584-.71,1.579-1.283,1.855-3.433,3.3-8.169,4.163L272.4,107.03l-8.879,4.736-1.717,2.723-1.44,3.946,4.3,1.874,1.579,1.717-1.579,1.855L256.2,129.9l-3.374,6.2,5.308.868",
    transform: "translate(-82.86 -62.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S137-3",
    transform: "translate(0 318.61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S137P1-4",
    className: "cls-3",
    d: "M29.6,384.2l1.006-.868-2.151-1.144-13.477-.868-5.15,1.006-4.578-.572,3.019-3.019,7.163-3.3L19.16,374l2.151-.434,3.019-2.289,6.886-1.579-21.35,1.164-4.874-2.289-.71-2.289-4.163-.3L0,360.979l7.893-5.091,4.3-1.973,4.44-.572,4.578-1.144,2.151-2.427-1.44-1.44-11.839-2.723-5.347-2.269.868-2.151L7.459,338.9l6.886-2.585,3.3.3,2.723,1.145,2.427,1.855,1.717,2.151,6.729,1.006-1.855-3.433,1.006-5.742-1.44-2.427,3.3-1.855,3.591-.71,6.59-3.946,1.973-.3,10.32,1.579,11.6.138,11.839-.868-5.012-3.729-1.855-3.591-5.742,4.578L61.82,323.9l-8.879-1.283-2.585-1.283-3.2-2.94-1.44.434-1.44,1.006-6.452,1.283-6.156-1.145,8.465-3.157L51.3,310.5l2.861-2.151,3.946-3.946-.138-2.427-1.44-1.717,9.037-8.169,2.723-1.283,4.163.868,3.433-.71,1.283.434,1.44-.3,3.374-2.309-3.433-3.019-3.946-2.151-12.984-2.723-1.579-.71-1.44-1.283-.572-1.579.138-3.591-.71-1.144-2.861-.71-3.157.138-1.855-.71-1.579-1.973,4.163-2.585L48.225,264.9l-4.163-.572-3.019-1.973.434-2.151,2.151-1.717-1.283-2.585.3-2.723,2.585-.71,2.151,1.144,5.308-.572,6.314.868-4.736-3.433-1.579-2.151.71-2.585,1.006-1.973,7.025-1.855,6.729.3.3-2.585,1.144-2.427-6.156-2.585H56.611l2.151-4.578,2.723-3.946,1.144-2.861.71-3.157-3.433.434,1.006-4.44-.434-3.3-4.874.71,1.283-3.946,1.973-2.427,2.585-.572,2.151,1.144,4.163,1.283,4.736-1.006,6.018,1.144,9.037,3.3,4.736,7.735,1.973-.71L97.85,216.4h1.44l9.235,4.262,5.446,3.729,1.717-.3.3-4.3-1.283-3.433,3.69-3.019,3.946-1.717,2.427-.71,5.308-.3,2.427-.868,2.723-4.578,3.433-3.433L125.909,200.6l-10.32-7.893,2.8-2.861,2.861-1.144,4.578-.434,1.006-1.579,2.427-.868,4.578-3.019.138-5.308,1.717-3.433,3.157-1.717,1.717-3.3,1.717-2.151,5.446.434,5.446-1.144,1.717.71,6.018,1.006,1.717,1.44.572-4.3,3.729.434,1.144,1.144-.138,3.157,1.144,2.289-.434,3.3-1.717,2.289-2.289,1.44,1.144,2.427-3.591,3.019,3.157-.868,5.012-2.585.434-2.861.3-3.729-.138-3.591,1.44-3.433,2.723-1.717,6.156.3-1.283-4.578,2.151.138,2.151,1.44,2.585,3.946,2.881,3.414,3.3,2.861-4.578,3.058-5.15,1.717L180.9,180.63l.868,2.585,2.861,1.44,3.157-1.579,4.874-6.018,2.289.138,2.289,1.144,4.874.3,9.175-1.144,3.789.809,4.874,3.019,3.946.868,2.289,5.742.138,8.031,2.585,8.6,4.163,7.893-.71,4.163-2.585,1.717-4.874,1.717-.71,2.861,3.157-.868h2.723l5.742,1.855,1.44,3.433.434,4.736V235.8l-1.44,3.946-1.283-1.579-.868-3.946-1.44-1.973-1.973-1.44-.138,5.012-1.855,6.452.868.71,2.723.868-3.394,6.058-4.44.868-4.736-.434-1.579,2.151-1.579,2.861L213.1,259.2l-3.729,1.855-3.729-1.44-3.3-2.861,1.006,2.723.138,2.585-3.019.3-2.861-1.283-1.855,1.283-.868,3.019.138,4.163,1.283,3.3v6.729l-.3,7.3,1.006,4.736-.71,5.308-.967,2.585-.71,4.736-1.283,1.44-.3,4.578.3,9.609v5.15L191.4,336.156l-2.723,3.729-3.2,3.453-2.723,4.163-2.289,4.736-2.585,7.893-7.459,8.307-2.7,1.855-2.861.868,3.946,7.893-5.308,1.855-5.15-.3-4.992-3.019-3.591-.572-3.591,1.441-1.579,1.006-.71-.868-.868-6.018-2.92,5.308L136.5,378.9l-5.308-1.717-9.313-.868-3.946.71-2.151,2.151-1.717,2.585-1.855,1.283-1.855.572-7.459.3-1.717.572-4.3,3.729-5.012,1.579-3.729-.138-2.427-3.433-.868-1.973L83.7,383.1l-4.775-1.2,1.283,1.144.434,2.151-.434,3.946-1.44,3.3-2.861,1.283-2.9-.493-5.446,2.427-6.156-.572-4.163,2.585-21.074.3-1.006-.138-2.289-2.289-2.723-1.44-3.157-.434-9.037,1.006-3.729-1.855,7.3-6.452L29.42,384.2",
    transform: "translate(0 -161.47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S921",
    transform: "translate(257.619 407.897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S921P1",
    className: "cls-3",
    d: "M146.681,221.637l1.44-2.427,2.723-2.585.3-8.6-.572-.868-1.144-.434L145.832,208l-5.742,6.59-3.946,1.973-3.433,6.729-2.151,2.861.71.3,2.861-.138,2.861,2.151,9.609-6.886",
    transform: "translate(-130.56 -206.72)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S922",
    transform: "translate(226.739 239.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S922P1",
    className: "cls-3",
    d: "M119.646,121.3l-4.736,3.591V125.9l2.151.138,3.433-2.151,2.289-2.151-.71-.572-2.427.138",
    transform: "translate(-114.91 -121.16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S923",
    transform: "translate(257.856 313.322)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S923P1",
    className: "cls-3",
    d: "M140.7,169.524l-.572-6.729-.572-1.717-2.151-2.289h-2.585l-1.283,1.006-1.283,1.283-1.579,3.157.138,9.609L132.535,176,134.113,177l4.736.868,1.144-2.861.71-5.446",
    transform: "translate(-130.68 -158.79)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S924",
    transform: "translate(234.454 243.629)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S924P1",
    className: "cls-3",
    d: "M140.19,134.52l-3.946-1.717-1.717-5.742-2.151-3.019-1.144-.572h-1.717l-4.3,1.283-1.006.71-.868,1.717v1.283l5.15,5.584-3.946,8.465-4.44.3-1.283,1.006v1.855l5.012,1.44,15.47-.3,2.861-9.609-2.151-2.723",
    transform: "translate(-118.82 -123.47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S925",
    transform: "translate(218.293 291.637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S925P1",
    className: "cls-3",
    d: "M127.816,147.82l-3.591,1.006-4.44,2.289-.868-1.44h-1.144l-1.717.71-1.579,1.144-1.006,1.579-.868,2.585-1.973,3.433v1.006h1.579l5.446-3.729,1.283-.138.434.71-1.283,2.861.3,3.946L116.1,166.94l-.138.868,1.973.434,6.886-1.973,1.855-2.151.434-1.855v-5.584l.71-8.879",
    transform: "translate(-110.63 -147.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S926",
    transform: "translate(236.21 282.027)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S926P1",
    className: "cls-3",
    d: "M127.859,146.541,126,148.988l-.138.868,1.855,1.579-5.584,2.151-1.717,1.973-.572,3.019-.138,1.717.434,1.283,1.855.572,1.006-.572,9.452-11.188,4.44-7.025-1.283-.434-1.579.434-6.156,3.157",
    transform: "translate(-119.71 -142.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S927",
    transform: "translate(476.051 6.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S927P1",
    className: "cls-3",
    d: "M245.206,3.12l-3.946,7.3,1.973,7.3,1.006-.572.434-1.006.71-4.3.3-3.591.138-.572H247.4l.572-1.855-.138-1.973-2.723-.71",
    transform: "translate(-241.26 -3.12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S928",
    transform: "translate(455.47 12.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S928P1",
    className: "cls-3",
    d: "M247.76,15.137l-1.973,1.006.3-4.874.868-4.6L244.978,6.1l-1.855.434L239.532,10.7l-1.973.572-.868,1.44.572,1.006,3.157,1.44.868,9.452-4.578,1.973-2.585-.868-3.157.572-.138,1.44.336,1.855.868.572,3.3.434.434.71-.3,1.855.3,1.44,2.585-.572,2.861.434.71,2.585v2.723L240.2,44.636l-3.433,8.307,1.44,2.427.71-.434,2.289-5.446,1.973-2.151,1.973-7.025.572-.71,1.006-3.433,1.006-1.855,4.44-11.326,1.144-4.163-2.585,1.44-1.283-.138-1.717-5.012",
    transform: "translate(-230.83 -6.1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S929",
    transform: "translate(485.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S929P1",
    className: "cls-3",
    d: "M248.959,9.866l.434-2.151,2.723-5.308.138-.868-.71-1.283L250.814,0,249.1,1.579l-.71-.868-.868.3-.572.868L245.94,5.308V8.6l.3.71,2.723.572",
    transform: "translate(-245.94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S930",
    transform: "translate(377.944 113.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S930P1",
    className: "cls-3",
    d: "M196.276,58.889l-2.723-1.579-1.44.434L191.54,59.6l.572,3.019,2.309,4.44,1.855.434,2.151-.572.434-.434-1.717-1.144-.138-.868.138-2.151-.868-3.433",
    transform: "translate(-191.54 -57.31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S931",
    transform: "translate(254.955 473.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S931P1",
    className: "cls-3",
    d: "M140.99,241.493l-5.92-1.283-4.578,1.283-1.283,8.6,1.973,6.314,2.151.434,1.283,3.3,4.3-1.855,3.729-2.427,5.308-2.151,1.855-2.427-4.163-.71-1.44-1.579-3.3-7.459",
    transform: "translate(-129.21 -240.21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S932",
    transform: "translate(408.193 92.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S932P1",
    className: "cls-3",
    d: "M212.158,46.93l-2.585.572-2.7,3.532,3.946.71,4.578-1.973,1.144-1.579-4.3-1.283",
    transform: "translate(-206.87 -46.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S933",
    transform: "translate(389.763 121.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S933P1",
    className: "cls-3",
    d: "M197.609,61.777l1.144,4.736,1.006,1.579.3-.138,1.44-3.946.908-1.579-1.44-.868-3.433.3",
    transform: "translate(-197.53 -61.56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S934",
    transform: "translate(381.239 98.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S934P1",
    className: "cls-3",
    d: "M211.423,63.714l-2.289-.572L205.7,60.991l-2.585-.434.71-1.579,1.717-1.579.3-1.283L204.97,54.4l-3.019-3.157L198.715,50l-2.289.572-2.151,4.163-.77,3.157-.3,2.151.434,1.144.868.434,2.585-1.717.138.71-.493,2.23V63.99l.71,1.144,1.006.572,6.314-.3,3.808,4.163h1.44l1.283-.71,1.717-3.019-1.579-2.151",
    transform: "translate(-193.21 -50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S939",
    transform: "translate(396.117 86.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S939P1",
    className: "cls-3",
    d: "M203.078,49.012l3.157,2.585-.592,4.2,1.006,1.579,3.3-1.006.71-2.151-.3-.572-2.723-1.44-.868-3.591-3.157-4.578-2.427.434-.434.572.868,2.427,1.44,1.44",
    transform: "translate(-200.75 -44.04)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S941",
    transform: "translate(232.994 119.753)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S941P1",
    className: "cls-3",
    d: "M126.446,100.312l1.973.434,5.446-4.578,4.163-1.144,6.729-3.946,1.006-1.144.572-2.289-.868-1.283-3.946-1.006,5.446-2.151,2.289-2.585,1.717.138L158.432,70.3l1.283-4.736.138-3.729-.434-1.144-2.289.572-10.32,4.874-7.893,2.427-1.579,1.006-.71,1.144.71,6.156-.138.572L134.339,76.3l-2.861.3L129.9,73.733l-1.855-1.283-.71.3-1.006,1.283-1.717.868-1.144,2.861-.434,2.861v1.144l1.283.868.434,1.283,1.006.572-2.861,1.579-.434.868,1.44,2.427,3.946,3.946.138.71L124.394,95.3l-.868,1.717-5.446,2.289,1.579,4.163.868,1.006.868.138,2.151-1.144,2.861-3.019",
    transform: "translate(-118.08 -60.69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S942",
    transform: "translate(242.366 215.432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S942P1",
    className: "cls-3",
    d: "M122.83,110.463l1.006,3.433,1.144,1.44,1.283.572,1.283-.71,1.006-1.144.3-1.579-.138-1.717-1.283-1.579-4.578,1.283",
    transform: "translate(-122.83 -109.18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S943",
    transform: "translate(237.986 174.074)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S943P1",
    className: "cls-3",
    d: "M131.245,116.811l.71,2.585,1.717,1.717,3.729,1.006,4.874-.138L140.559,132l.868.71,1.44.3,1.44-.868,5.742-4.578,4.3-2.723,1.44-1.579.3-1.717-.868-1.44-6.314-1.006-6.452-2.861-.572-1.44-1.283-1.283.434-2.585.138-3.946,1.44-3.3.868-3.019.572-5.446-1.717-5.012-1.717-1.855-1.973-.138-1.717,3.946-9.175.71-.138.71.572,2.427-.138.868-1.144.868-1.44.3-1.855-1.44-2.427,1.973-.572,1.006.3,2.151,1.44,3.946,7.6,4.3,1.44,6.729",
    transform: "translate(-120.61 -88.22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S944",
    transform: "translate(214.268 165.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S944P1",
    className: "cls-3",
    d: "M120.765,84.146l-2.723,1.144-1.717-.868-2.723.572-1.44-1.144h-1.144l-1.283.868-1.006,1.144-.138,1.006,5.584,6.156,4.874,1.283,4.736-5.446-3.019-4.716",
    transform: "translate(-108.59 -83.85)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S945",
    transform: "translate(210.46 184.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S945P1",
    className: "cls-3",
    d: "M114.2,94.128l-3.946-.868-1.44,5.584-1.717,4.44-.434,2.427.138,4.44.868,1.283,1.855.868h1.756l.138-.71,3.729-16.476-.868-1.006",
    transform: "translate(-106.66 -93.26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S946",
    transform: "translate(45.502 378.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S946P1",
    className: "cls-3",
    d: "M28.289,193.193l-1.283-1.283-3.946,1.717,7.459,3.433.572,3.019,2.151,3.157.71-1.855,1.144-5.012-1.283-1.44-5.446-1.717",
    transform: "translate(-23.06 -191.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S947",
    transform: "translate(201.955 207.579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S947P1",
    className: "cls-3",
    d: "M103.633,105.437l-1.283,2.151v.868l1.006.868,3.433-.138.868-1.006v-1.4l-1.283-1.579-2.723.138",
    transform: "translate(-102.35 -105.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "gF1S967",
    transform: "translate(345.307 676.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polyF1S967P1",
    className: "cls-3",
    d: "M186.721,343.058l-3.433,2.289-5.92,1.144L175,348.623l1.973.138L185,355.647l2.427.434,2.427-.3,1.006-1.006,1.579-2.585,3.946-1.717-2.861-3.591-6.886-3.946",
    transform: "translate(-175 -342.94)"
  })))))), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/bristol",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Bristol"), /*#__PURE__*/React.createElement("circle", {
    id: "bristol",
    "data-name": "Ellipse 316",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(649.953 1670.471)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/sheffield",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Sheffield"), /*#__PURE__*/React.createElement("circle", {
    id: "sheffield",
    "data-name": "Ellipse 317",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(719.724 1549.673)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/bath",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Bath"), /*#__PURE__*/React.createElement("circle", {
    id: "bath",
    "data-name": "Ellipse 318",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(666.614 1680.885)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "London"), /*#__PURE__*/React.createElement("circle", {
    id: "london",
    "data-name": "Ellipse 319",
    className: "active",
    cx: 27.075,
    cy: 27.075,
    r: 27.075,
    transform: "translate(736.386 1666.306)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/bournemouth",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Bournemouth"), /*#__PURE__*/React.createElement("circle", {
    id: "bournemouth",
    "data-name": "Ellipse 320",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(671.821 1720.456)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/chelmsford",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Chelmsford"), /*#__PURE__*/React.createElement("circle", {
    id: "chelmsford",
    "data-name": "Ellipse 321",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(787.412 1666.306)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/colchester",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Colchester"), /*#__PURE__*/React.createElement("circle", {
    id: "colchester",
    "data-name": "Ellipse 322",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(803.033 1655.892)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/worthing",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Worthing"), /*#__PURE__*/React.createElement("circle", {
    id: "worthing",
    "data-name": "Ellipse 323",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(743.675 1726.705)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/ipswich",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Ipswich"), /*#__PURE__*/React.createElement("circle", {
    id: "ipswich",
    "data-name": "Ellipse 326",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(819.695 1644.437)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/norwich",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Norwich"), /*#__PURE__*/React.createElement("circle", {
    id: "norwich",
    "data-name": "Ellipse 327",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(824.901 1607.99)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/birmingham",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Birmingham"), /*#__PURE__*/React.createElement("circle", {
    id: "birmingham",
    "data-name": "Ellipse 328",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(689.524 1617.361)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/leicester",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Leicester"), /*#__PURE__*/React.createElement("circle", {
    id: "leicester",
    "data-name": "Ellipse 329",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(727.013 1609.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/barnsley",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Barnsley"), /*#__PURE__*/React.createElement("circle", {
    id: "barnsley",
    "data-name": "Ellipse 330",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(718.682 1530.929)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/cardiff",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Cardiff"), /*#__PURE__*/React.createElement("circle", {
    id: "cardiff",
    "data-name": "Ellipse 331",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(629.125 1657.975)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/york",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "York"), /*#__PURE__*/React.createElement("circle", {
    id: "york",
    "data-name": "Ellipse 332",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(743.675 1503.853)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/cambridge",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Cambridge"), /*#__PURE__*/React.createElement("circle", {
    id: "cambridge",
    "data-name": "Ellipse 352",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(789.013 1625.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/st-albans",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "St Albans"), /*#__PURE__*/React.createElement("circle", {
    id: "st-albans",
    "data-name": "Ellipse 353",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(755.013 1660.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/maidstone",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Maidstone"), /*#__PURE__*/React.createElement("circle", {
    id: "maidstone",
    "data-name": "Ellipse 354",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(787.013 1697.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/brighton",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Brighton"), /*#__PURE__*/React.createElement("circle", {
    id: "brighton",
    "data-name": "Ellipse 355",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(755.013 1727.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/portsmouth",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Portsmouth"), /*#__PURE__*/React.createElement("circle", {
    id: "portsmouth",
    "data-name": "Ellipse 356",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(720.013 1718.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/southampton",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Southampton"), /*#__PURE__*/React.createElement("circle", {
    id: "southampton",
    "data-name": "Ellipse 357",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(702.013 1710.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/exeter",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Exeter"), /*#__PURE__*/React.createElement("circle", {
    id: "exeter",
    "data-name": "Ellipse 358",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(592.013 1710.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/plymouth",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Plymouth"), /*#__PURE__*/React.createElement("circle", {
    id: "plymouth",
    "data-name": "Ellipse 359",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(557.013 1720.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/woking",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Woking"), /*#__PURE__*/React.createElement("circle", {
    id: "woking",
    "data-name": "Ellipse 360",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(729.013 1692.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/reading",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Reading"), /*#__PURE__*/React.createElement("circle", {
    id: "reading",
    "data-name": "Ellipse 361",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(717.013 1679.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/oxford",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Oxford"), /*#__PURE__*/React.createElement("circle", {
    id: "oxford",
    "data-name": "Ellipse 362",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(709.013 1660.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/nottingham",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Nottingham"), /*#__PURE__*/React.createElement("circle", {
    id: "nottingham",
    "data-name": "Ellipse 363",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(727.013 1589.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/liverpool",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Liverpool"), /*#__PURE__*/React.createElement("circle", {
    id: "liverpool",
    "data-name": "Ellipse 364",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(658.013 1531.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/leeds",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Leeds"), /*#__PURE__*/React.createElement("circle", {
    id: "leeds",
    "data-name": "Ellipse 365",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(717.013 1511.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/manchester",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Manchester"), /*#__PURE__*/React.createElement("circle", {
    id: "manchester",
    "data-name": "Ellipse 367",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(688.013 1527.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/newcastle",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Newcastle"), /*#__PURE__*/React.createElement("circle", {
    id: "newcastle",
    "data-name": "Ellipse 368",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(735.013 1419.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/edinburgh",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Edinburgh"), /*#__PURE__*/React.createElement("circle", {
    id: "edinburgh",
    "data-name": "Ellipse 369",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(687.013 1362.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/glasgow",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Glasgow"), /*#__PURE__*/React.createElement("circle", {
    id: "glasgow",
    "data-name": "Ellipse 370",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(644.013 1357.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/belfast",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Belfast"), /*#__PURE__*/React.createElement("circle", {
    id: "belfast",
    "data-name": "Ellipse 505",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(559.013 1425.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/coventry",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Coventry"), /*#__PURE__*/React.createElement("circle", {
    id: "coventry",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(710.524 1622.361)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/huddersfield",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Huddersfield"), /*#__PURE__*/React.createElement("circle", {
    id: "huddersfield",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(705.013 1518.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/poole",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Poole"), /*#__PURE__*/React.createElement("circle", {
    id: "poole",
    "data-name": "Ellipse 320",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(662.821 1720.456)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/slough",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Slough"), /*#__PURE__*/React.createElement("circle", {
    id: "slough",
    "data-name": "Ellipse 361",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(724.013 1677.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/solihull",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Solihull"), /*#__PURE__*/React.createElement("circle", {
    id: "solihull",
    "data-name": "Ellipse 328",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(695.524 1623.361)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/stockport",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Stockport"), /*#__PURE__*/React.createElement("circle", {
    id: "stockport",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(690.013 1534.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/swindon",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Swindon"), /*#__PURE__*/React.createElement("circle", {
    id: "swindon",
    "data-name": "Ellipse 318",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(688.614 1670.885)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/derby",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Derby"), /*#__PURE__*/React.createElement("circle", {
    id: "derby",
    "data-name": "Ellipse 363",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(717.013 1593.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/trafford",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Trafford"), /*#__PURE__*/React.createElement("circle", {
    id: "trafford",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(682.013 1534.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/swansea",
    target: "_parent",
    display: "none"
  }, /*#__PURE__*/React.createElement("title", null, "Swansea"), /*#__PURE__*/React.createElement("circle", {
    id: "swansea",
    "data-name": "Ellipse 331",
    className: "proposed",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(609.125 1647.975)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/crewe",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Crewe"), /*#__PURE__*/React.createElement("circle", {
    id: "crewe",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(678.013 1547.031)"
  })), /*#__PURE__*/React.createElement("a", {
    href: "https://www.goodgym.org/areas/warwick",
    target: "_parent"
  }, /*#__PURE__*/React.createElement("title", null, "Warwick and Leamington Spa"), /*#__PURE__*/React.createElement("circle", {
    id: "warwick",
    "data-name": "Ellipse 367",
    className: "active",
    cx: 8.331,
    cy: 8.331,
    r: 8.331,
    transform: "translate(710.524 1632.361)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.0511b51f49a43094a3793f3efc3322c1.svg";
export { ForwardRef as ReactComponent };